import {
    Callout,
    getFocusStyle,
    getTheme,
    Icon,
    Link,
    List,
    mergeStyleSets,
    Spinner,
    Stack,
    StackItem,
    Text,
} from "@fluentui/react";
import React, {ReactNode, useCallback, useContext, useEffect, useState,} from "react";
import {useTranslation} from "react-i18next";
import Axios from "axios";
import {useNavigate} from "react-router-dom";
import {SharedColors} from "@fluentui/theme";
import {useBoolean} from "@fluentui/react-hooks";
import {UnreadTicketDto} from "../API";
import {AppRoute} from "../AppRoutes";
import * as indexObject from "../index";
import {calloutTypes} from "./TopBar";
import {AuthContext} from "../contexts/AuthContext";
import {LanguageContext} from "../contexts/LanguageContext";
import "../styles/UnreadMessagesCallout.css";
import {SupportMessageColorHelper} from "../helpers/SupportMessageColorHelper";

interface IUnreadMessagesCountProps {
    setShowingCallout: (a?: calloutTypes) => void;
    showingCallout?: calloutTypes;
}

const theme = getTheme();
const {palette, semanticColors, fonts} = theme;

const classNames = mergeStyleSets({
    itemCell: [
        getFocusStyle(theme, {inset: -1}),
        {
            boxSizing: "border-box",
            // borderBottom: `1px solid ${semanticColors.bodyDivider}`,
            display: "flex",
            selectors: {
                "&:hover": {background: palette?.neutralLighter, cursor: "pointer"},
            },
            minWidth: 200,
            maxWidth: 300,
            overflow: "hidden",
            textOverflow: "ellipsis",
        },
    ],
    selectedItemCell: [
        getFocusStyle(theme, {inset: -1}),
        {
            background: palette.neutralLight,
            boxSizing: "border-box",
            borderBottom: `1px solid ${semanticColors.bodyDivider}`,
            display: "flex",
            selectors: {
                "&:hover": {cursor: "pointer"},
            },
            minWidth: 200,
        },
    ],
});

export enum TicketType {
    IsNotAssigned,
    YourTicket,
    DelegatedToYou,
    DelegatedTicket,
}

type GroupedMessages = {
    title: string;
    ticketId: number;
    userId: string;
    user: string;
    agentId?: string;
    agent: string;
    messages: UnreadTicketDto[];
};

export const UnreadMessagesCallout = ({
                                          setShowingCallout,
                                          showingCallout,
                                      }: IUnreadMessagesCountProps) => {
    const {t} = useTranslation();
    const {UserInfo} = useContext(AuthContext);
    const {moment} = useContext(LanguageContext);
    const history = useNavigate();
    const [grouped, setGrouped] = useState<GroupedMessages[]>();
    const [loading, {setTrue: setLoading, setFalse: setNotLoading}] =
        useBoolean(false);

    useEffect(() => {
        setGrouped(undefined);
        if (showingCallout) {
            setLoading();
            Axios.get<GroupedMessages[]>("support/" + showingCallout)
                .then(({data}) => {
                    setGrouped(data);
                    // data = data.sort((a, b) => {
                    //     return a.messageId - b.messageId;
                    // });
                    // const groupedData = data.reduce<GroupedMessages[]>((p, c) => {
                    //     const existing = p.find(f => f.ticketId == c.id);
                    //     if (existing) {
                    //         existing.messages.push(c);
                    //     } else {
                    //         p.push({
                    //             ticketId: c.id ?? 0,
                    //             title: c.title,
                    //             userId: c.userId,
                    //             user: c.user,
                    //             agent: c.agent,
                    //             agentId: c.agentId,
                    //             messages: [c]
                    //         })
                    //     }
                    //     return p.map(m => {
                    //         if (showingCallout == "UnfinishedTasks") {
                    //             m.messages = m.messages.filter(f => f.isTask && !f.isTaskDone);
                    //         } else {
                    //             m.messages = [m.messages[m.messages.length - 1]];
                    //         }
                    //         return m;
                    //     });
                    // }, []);
                    // const ret = groupedData.sort((a, b) => {
                    //     return a.ticketId - b.ticketId;
                    // });
                    // setGrouped(ret);
                })
                .finally(setNotLoading);
        }
    }, [showingCallout]);

    const renderListCell = useCallback(
        (
            item?:
                | { key: string; name: string; data: GroupedMessages; isLast: boolean }
                | undefined,
            index?: number,
            isScrolling?: boolean,
        ): ReactNode => {
            let ticketType: TicketType = TicketType.IsNotAssigned;

            if (!!item?.data.userId) {
                const thisUserId = UserInfo?.user?.id;
                const userId = item.data.userId;
                const agentId = item.data.agentId;
                if (userId == thisUserId && agentId == thisUserId) {
                    ticketType = TicketType.YourTicket;
                } else if (userId != thisUserId) {
                    ticketType = TicketType.DelegatedToYou;
                } else if (agentId != thisUserId) {
                    ticketType = TicketType.DelegatedTicket;
                }
            }

            const colorFromType = (type?: string, message?: UnreadTicketDto) => {
                return SupportMessageColorHelper(
                    {
                        private: type == "PRIVATE",
                        inbound: type == "INBOUND",
                        isTask: message?.isTask,
                        isTaskDone: message?.isTaskDone,
                    } as any,
                    undefined,
                );
            };

            // const colors = SupportMessageColorHelper({
            //     isTask: showingCallout === "UnfinishedTasks",
            //     inbound: showingCallout === "UnassignedTickets"
            // } as any, undefined);

            const colors = colorFromType(
                item?.data.messages[0]?.type,
                item?.data.messages[0],
            );

            const lastMessageId = item?.data.messages[0]?.messageId;
            const lastActivityDate = item?.data.messages[0]?.date;
            const lastActivityFromNow =
                showingCallout === "OldTickets" && lastActivityDate
                    ? moment(lastActivityDate).fromNow()
                    : undefined;

            // return <ActivityItem
            //     className={classNames.itemCell}
            //     activityDescription={item?.data.title}
            //     // activityIcon={<Icon iconName="Message" />}
            //     comments={item?.data.messages.filter(f => !!f).map(m => {
            //         return <p style={{ padding: 0, margin: 0 }}>{m?.content?.trim()}</p>
            //     })}
            //     activityPersonas={[{
            //         imageInitials: StringHelpers.extractInitials(item?.data.agent ?? " - "),
            //     }]}
            // />

            return (
                <Stack
                    key={item?.key + "" + item?.name}
                    onClick={() => {
                        history(
                            AppRoute.EDIT_SUPPORT_TICKET(item?.data?.ticketId, lastMessageId),
                        );
                        setShowingCallout(undefined);
                    }}
                    className={classNames.itemCell}
                    style={{
                        borderTop: "1px solid rgb(200, 198, 196)",
                        borderRight: "1px solid rgb(200, 198, 196)",
                        borderLeft: "3px solid " + colors.originalMessageColor,
                    }}
                >
                    {/* Bilo bi super ovdje staviti activity indicator a ne ovo */}
                    <Stack
                        horizontal
                        horizontalAlign={"space-between"}
                        verticalAlign={"center"}
                        style={{paddingLeft: 5, paddingTop: 5, paddingRight: 5}}
                    >
                        <Stack horizontal tokens={{childrenGap: 5}}>
                            <small>
                                <b style={{color: indexObject?.theme.palette?.themeTertiary}}>
                                    {item?.key}
                                </b>
                            </small>
                            <small>{item?.name}</small>
                        </Stack>
                        <Icon
                            iconName={"ChevronRight"}
                            style={{color: indexObject?.theme.palette?.themePrimary}}
                        />
                    </Stack>
                    <Stack>
                        {item?.data.messages.map((m) => {
                            if (m) {
                                return (
                                    <Stack
                                        horizontal
                                        horizontalAlign="stretch"
                                        key={m.messageId}
                                        style={{
                                            position: "relative",
                                            paddingLeft: 5,
                                            paddingTop: 5,
                                            paddingRight: 5,
                                            paddingBottom: 5,
                                            borderBottom: "1px solid rgb(200, 198, 196)",
                                        }}
                                    >
                                        <StackItem align="stretch" style={{flex: 1}}>
                                            <Text>{m.content?.trim()}</Text>
                                        </StackItem>
                                        <Text
                                            className="bottom-contact-text-unread"
                                            style={{position: "absolute", right: 5, bottom: 5}}
                                            variant="xSmall"
                                        >
                                            {m.contact ?? " - "}
                                        </Text>
                                    </Stack>
                                );
                            }
                        })}
                        <Stack
                            horizontal
                            horizontalAlign={"space-between"}
                            verticalAlign={"end"}
                            className="notification-unread-footer"
                        >
                            <b>
                                {
                                    {
                                        [TicketType.IsNotAssigned]: (
                                            <small style={{color: SharedColors.red10}}>
                                                {t("not-assigned-ticket")}
                                            </small>
                                        ),
                                        [TicketType.YourTicket]: (
                                            <small
                                                style={{
                                                    color: indexObject.theme.palette?.themePrimary,
                                                }}
                                            >
                                                {t("your-ticket")}
                                            </small>
                                        ),
                                        [TicketType.DelegatedToYou]: (
                                            <Stack>
                                                <small style={{color: SharedColors.orange10}}>
                                                    {t("ticket-delegated-to-you")}
                                                </small>
                                                {item?.data.user ? (
                                                    <small>
                                                        {t("by")}: {item?.data.user}
                                                    </small>
                                                ) : null}
                                            </Stack>
                                        ),
                                        [TicketType.DelegatedTicket]: (
                                            <Stack>
                                                <small style={{color: SharedColors.gray10}}>
                                                    {t("ticket-you-delegated")}:{" "}
                                                    <Link>{item?.data.agent}</Link>
                                                </small>
                                            </Stack>
                                        ),
                                    }[ticketType]
                                }
                            </b>
                            {lastActivityFromNow && (
                                <Text variant="xSmall" style={{color: SharedColors.gray10, paddingRight: 5}}>
                                    {t("last-activity")}: {lastActivityFromNow}
                                </Text>
                            )}
                        </Stack>
                    </Stack>
                </Stack>
            );
        },
        [UserInfo, showingCallout],
    );

    if (!showingCallout) return null;

    return (
        <Callout
            title={t(showingCallout)}
            hidden={false}
            target={"#" + showingCallout}
            preventDismissOnScroll
            setInitialFocus={false}
            isBeakVisible={true}
            onDismiss={() => setShowingCallout(undefined)}
        >
            {loading && (
                <Stack style={{padding: 10}}>
                    <Spinner/>
                </Stack>
            )}
            <List
                id={"id"}
                items={grouped?.map((m, index) => ({
                    key: m.ticketId + "",
                    name: m.title?.trim()?.length ? m.title : t("no-title"),
                    data: m,
                    isLast: index == grouped?.length - 1,
                }))}
                onRenderCell={renderListCell}
            />
        </Callout>
    );
};
